import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import styles from './styles.module.less';

type MenuLabelProps = {
  idLabelMessage: string;
  className?: string;
  to?: string;
  target?: string;
  count?: number;
};

function MenuLabel({
  idLabelMessage,
  className,
  to,
  target = '_self',
  count,
}: MenuLabelProps) {
  const intl = useIntl();
  const label = intl.formatMessage({ id: idLabelMessage });
  const content = (
    <>
      {label}
      {count != null && count > 0 ? (
        <span aria-hidden className={styles.count}>
          {count}
        </span>
      ) : null}
    </>
  );

  if (!to) {
    return (
      <span className={className} title={label}>
        {content}
      </span>
    );
  }

  if (target === '_blank') {
    return (
      <a
        className={className}
        href={to}
        rel="noopener noreferrer"
        target={target}
        title={label}
      >
        {content}
      </a>
    );
  }

  return (
    <Link className={className} title={label} to={to}>
      {content}
    </Link>
  );
}

export default memo(MenuLabel);
